import { render, staticRenderFns } from "./IconSvgPass.vue?vue&type=template&id=4a95d248&scoped=true&"
import script from "./IconSvgPass.vue?vue&type=script&lang=js&"
export * from "./IconSvgPass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a95d248",
  null
  
)

export default component.exports